/**
 * Knowledge Base Service - Handles API interactions for knowledge base management
 */

import { post, put,get } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/persistence/upload`;
const RETRIEVE_API = `/api/v1/persistence/files`;


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const uploadFile = async (file, entityId, filetype, fileId) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await post(`${API_URL}/${entityId}/${filetype}/${fileId}`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const listFiles = async (entity_id, file_type = null, file_id=null, query=null) => {
  try {
    const filter = {};
    if (entity_id) {
      filter.entity_id = entity_id;
    }
    if (file_type) {
      filter.file_type = file_type
    }
    if (file_id) {
      filter.file_id = file_id
    }
    const sort = {};
    const response = await post(`${RETRIEVE_API}/fetch?${query}`, {filter:filter, sort:sort});
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};
export const downloadImage = async (fileUrl) => {
  try {
    const profile = await get(`/api/v1/persistence/download${fileUrl}`, {
      withCredentials: true,
      responseType: 'blob',
    });
    const imageUrl = URL.createObjectURL(profile);
    return imageUrl;
  } catch (error) {
    console.error('Error downloading image:', error);
    throw error;
    
  }
};
export default {
  uploadFile,
  listFiles,
  downloadImage
};

